import type { Scan } from "@hobbyshopify/backend-client";
import { Rx } from "subtree.js/core";

/** Which section of the app the scan is reviewed under; decides the wording and where cancel returns. */
export type EditScanKind = "customer" | "shop";
/** `?mode=`, kept for the links that carry it; the review screen words its button from the scan itself. */
export type EditScanMode = "edit" | "review" | "approve";
export type EditScanStatus = "loading" | "ready" | "notFound" | "error";

export class EditScanState {
  readonly noMatch = new Rx<Scan | null>(null);
  readonly status = new Rx<EditScanStatus>("loading");

  constructor(
    readonly kind: EditScanKind,
    readonly mode: EditScanMode,
    /** "2 of 5", when the scan was opened from a list to walk; null for one scan. */
    readonly position: { readonly index: number; readonly total: number } | null,
    /** Whether Skip has somewhere to go. */
    readonly canSkip: boolean,
  ) {}
}

export abstract class EditScanActions {
  abstract cancel(): void;
  /** Moves on to the next scan of the list without deciding this one. */
  abstract skip(): void;
  abstract retry(): void;
}
